import { Box, Stack, Typography } from "@mui/material";

import { isDesktop, isMobile, isSmallDesktop } from "@hooks/layout";

import styled from "styled-components";

export const BottomPlayer = styled.div`
  z-index: 1000;
  background: transparent;
  max-width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 24px 16px;
  transition: transform 0.35s ease, opacity 0.3s ease;

  ${isMobile} {
    padding: 0 12px 12px;
  }
`;

export const SongAuthor = styled(Typography)`
  color: ${({ theme }) => theme.palette.textColor.subtitle};
  font-family: Kaisei Opti;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;

  text-decoration-thickness: 1px;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;

  &:hover {
    text-decoration-line: underline;
  }

  cursor: pointer;
`;

export const SongTitle = styled(Typography)`
  display: inline-block;
  color: ${({ theme }) => theme.palette.textColor.highlighted};
  font-family: Kaisei Opti;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 135%;

  text-overflow: clip;
  white-space: nowrap;

  text-decoration-thickness: 1px;
  text-decoration-skip-ink: auto;
  text-underline-offset: 2px;

  &:hover {
    text-decoration-line: underline;
  }

  cursor: pointer;
`;

export const TimeDuration = styled(Typography)`
  color: ${({ theme }) => theme.palette.textColor.common};
  font-family: Kantumruy Pro;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 300;
  line-height: 150%;
`;

export const WaveFormStack = styled(Stack)<{ $isCurrent: boolean }>`
  #waveform ::part(cursor) {
    width: ${({ $isCurrent }) => ($isCurrent ? "2px" : "0")};
  }
`;

export const AlbumCover = styled.img<{ $width?: number }>`
  border-radius: 4px;
  width: ${({ $width }) => `${$width || 48}px`};
  height: auto;
  box-shadow: none;
  transition: box-shadow 0.3s ease-in-out;

  &:hover {
    box-shadow: rgba(0, 0, 0, 0.3) 0px 7px 29px 0px;
  }

  cursor: pointer;
`;

export const PlayerRow = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto;
`;

export const SongStack = styled(Stack)`
  flex: 1;
  min-width: 0;
  position: relative;
  overflow: visible;
  border-radius: 20px;

  padding: 10px 12px;

  ${isSmallDesktop} {
    padding: 12px 12px;
  }

  ${isDesktop} {
    padding: 12px 14px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -22px;
  right: 16px;

  width: 45px;
  height: 45px;
  border: 2px solid transparent;
  border-radius: 50%;
  border-left-color: rgba(235, 191, 126, 0.32);
  border-top-color: rgba(235, 191, 126, 0.32);
  transform: rotate(45deg);

  cursor: pointer;

  background: rgba(75, 55, 39, 1);

  svg {
    margin-right: 4px;
    width: 12px;
    height: 12px;
    transform: rotate(-45deg);
    -webkit-backface-visibility: initial !important;
    -webkit-transform-origin: 50% 50%;
  }

  path {
    stroke: #ac8d75;

    transition: stroke 0.3s ease-in-out;
  }

  &:hover {
    path {
      stroke: #ffdca8;
    }
  }

  ${isSmallDesktop} {
    right: 40px;
  }

  ${isDesktop} {
    right: 250px;
  }
`;

export const CloseButtonWrapper = styled.div`
  position: relative;
  max-width: 2260px;
  width: 100%;
  margin: 0 auto;
`;

export const BottomPlayerTooltip = styled(Box)`
  position: relative;
  cursor: pointer;

  & .tooltip {
    z-index: 1500;
    visibility: hidden;
    position: absolute;
    background-color: #ffdca8;
    color: #3c2d23;
    padding: 8px 16px;
    border-radius: 8px;
    /* Match the /music single-item waveform hover pill: system font stack so
       the position/duration numerals read cleanly (Raleway's old-style
       numerals look bad for times). */
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
    font-size: 0.8125rem;
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, -8px);
    white-space: nowrap;
    font-weight: 300;
    line-height: 150%;

    opacity: 0;
    transition: opacity 200ms cubic-bezier(0.4, 0, 0.2, 1), transform 133ms cubic-bezier(0.4, 0, 0.2, 1);
    pointer-events: none;
  }

  &:hover .tooltip {
    visibility: visible;
    opacity: 1;
  }
`;
